var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AdminCard',[_c('v-tabs',{attrs:{"vertical":""}},[_vm._l((_vm.$options.filters.roleEntries(_vm.tabs)),function(tab,i){return _c('v-tab',{key:i,attrs:{"disabled":tab.disabled,"to":tab.link}},[_vm._v(_vm._s(tab.name))])}),_c('v-tabs-items',[_c('router-view')],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }